import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import HelpOutline from '@material-ui/icons/HelpOutline';
import Grid from '@material-ui/core/Grid';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(4),
  },
  spacing: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(3),
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    padding: theme.spacing(3),
  },
  bold: {
    fontWeight: 'bold'
  },
}));

export default function PaperPrivate(props) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Grid className={classes.container} container justifyContent="center">
      <Paper className={classes.paper}>
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
          <HelpOutline color="primary" fontSize="large" /><Typography color="primary" variant="h5">ドキュメントが閲覧できません</Typography>
        </div>
        <Box m={1}/>
        <Typography paragraph>配信元によって公開が停止されています。</Typography>
      </Paper>
    </Grid>
  );
}